import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import { RELATED_PARTY_RELATIONSHIP } from '../../constants';
const {
  formField: { principalState },
} = loanFormModel;

export class PrincipalStateValidation implements ValidationSchema {
  public name = principalState.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalState.requiredErrorMsg,
    value: principalState.required,
  };
  public nullable = true;

  public when(schema: any, context: any) {
    const isPrincipal =
      context.parent.relationship == RELATED_PARTY_RELATIONSHIP.PRINCIPAL;
    if (isPrincipal) return schema.required(principalState.requiredErrorMsg);

    return schema.notRequired();
  }
}
export default new Validation(new PrincipalStateValidation());
